'use client';

import breakpoints from '@carvana/merch-tailwind/breakpoints';
import { appAssetsCdnUrl } from '~/constants/environment';
import GeolocationButton from './GeolocationButton';
import {
  GoldText,
  Heading,
  HeroWrapper,
  Subtitle,
  TextContent
} from './Hero.styles';
import MakeHeroIcon from './MakeHeroIcon';

type OwnProps = {
  make: string;
};

export default function MakeHero({ make }: OwnProps) {
  const heroBackgroundMobileSrc = `${appAssetsCdnUrl}/images/new-car/hero-make-background-small-new.svg`;
  const heroBackgroundDesktopSrc = `${appAssetsCdnUrl}/images/new-car/hero-make-background-large.svg`;

  return (
    <HeroWrapper data-testid="hero" className="h-[205px]">
      <picture aria-hidden="true">
        <source
          media={`(min-width: ${breakpoints.md}px)`}
          srcSet={heroBackgroundDesktopSrc}
        />
        <img
          alt=""
          className="absolute inset-0 size-full object-cover object-[center_70%] md:object-[53%_80%]"
          src={heroBackgroundMobileSrc}
        />
      </picture>
      <TextContent>
        <Heading className="max-w-[213px] md:max-w-full md:t-heading-3xl">
          <span>Find your perfect </span>
          <br className="md:hidden" />
          <GoldText className="t-heading-xl md:t-heading-3xl">{make}</GoldText>
        </Heading>
        <Subtitle className="max-w-[213px] md:max-w-full">
          All brand new models — pickup or delivery as soon as today!
        </Subtitle>
        <GeolocationButton />
      </TextContent>
      <div className="absolute bottom-2xl right-2xl sm:right-4xl md:right-[120px] lg:right-[209px] z-10 flex items-center justify-center sm:top-1/2 sm:bottom-auto sm:-translate-y-1/2 ">
        <MakeHeroIcon make={make} />
      </div>
    </HeroWrapper>
  );
}
